import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { TablePageTitle } from 'src/common/components/AppLayout/TablePage/TablePageTitle';

const ActivityLogPageTitle = () => {
  const { t } = useTranslation();

  return <TablePageTitle>{t('activityLog.title')}</TablePageTitle>;
};

export const ActivityLogPageLayout = ({ children }: { children: React.ReactNode }) => {
  return <PageLayout title={<ActivityLogPageTitle />}>{children}</PageLayout>;
};
